export default __webpack_public_path__ + "static/media/money-back@3x.f43b6a64.png";